<div class="row" *ngIf="section">
  <json-edit
    [object]="section"
    [processing]="processing"
    [type]="'Inspection Section'"
    (toggleSave)="saveInspectionSection($event)"
    (toggleCancel)="cancel()"
  ></json-edit>
</div>
